import React from "react";
import PropTypes from "prop-types";
import { FluentBadge } from "../../../../components/FluentUI/Fluent-Badge";
import { FluentTooltip } from "../../../../components/FluentUI/Fluent-Tooltip";
import "./organization.scss";

const CustomStatus = ({ status  }) => {
    const className = `organization-${status?.toLowerCase()??""}`;
    return (
        <td className="k-table-td td-status" data-testid="fluent-tooltip">
            <FluentTooltip
                target={
                    <div className={className}>
                        <FluentBadge
                            shape="rounded"
                            appearance="tint"
                            size="extra-large"
                            text={status??""}
                        />
                    </div>
                }
                text={status??""}
            />
        </td>
    );
};

CustomStatus.propTypes = {
    status: PropTypes.string,
};

export default CustomStatus;
